'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSoupCan = function IoSoupCan(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.5 6.3c0-3.4 4.1-5 12.5-5s12.5 1.6 12.5 5-4.1 5-12.5 5-12.5-1.7-12.5-5z m12.5 28.1c-3.4 0-6.2-0.5-8.5-1.4s-3.4-2.2-3.4-3.6v-10c0 0.7 0.3 1.5 1 2.1s1.7 1.2 2.9 1.6 2.6 0.8 4.3 1c0 1 0.5 1.8 1.2 2.5s1.6 0.9 2.5 0.9 1.8-0.3 2.5-0.9 1.2-1.5 1.3-2.5c2.4-0.3 4.3-0.9 5.8-1.8s2.3-1.8 2.3-2.9v10c0 1.4-1.1 2.6-3.4 3.6s-5.1 1.4-8.5 1.4z m0-21.9c3.4 0 6.4-0.5 8.8-1.4s3.7-2.2 3.7-3.6v0.6c0 0.4-0.1 0.9-0.2 1.4s-0.2 0.9-0.4 1.1v7.5c0 1.1-0.8 2.1-2.3 3s-3.4 1.5-5.9 1.8c-0.2-0.9-0.7-1.5-1.4-2s-1.4-0.9-2.3-0.9-1.6 0.3-2.3 0.9-1.2 1.1-1.4 2c-2.5-0.3-4.4-0.9-5.9-1.8s-2.3-1.9-2.3-3v-7.5c-0.4-0.4-0.6-1.4-0.6-3.1 0 1.4 1.2 2.7 3.7 3.6s5.4 1.4 8.8 1.4z m11.9 18.1v1.9l0.6 1.3c0 0.5-0.2 1-0.6 1.5-0.9 1-2.4 1.9-4.6 2.5s-4.6 1-7.3 1-5.2-0.4-7.3-1-3.7-1.5-4.6-2.5c-0.4-0.5-0.6-1-0.6-1.5l0.6-1.3v-1.9c0 1.4 1.1 2.7 3.4 3.6s5.1 1.4 8.5 1.4 6.3-0.4 8.5-1.4 3.4-2.2 3.4-3.6z' })
        )
    );
};

exports.default = IoSoupCan;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/soup-can.js
// module id = 2497
// module chunks = 0